import React, { useState } from 'react';

export default function AlertCard({ alert, onReview, onDetail }) {
  const [note, setNote] = useState('');
  const tierClass = `alert-card--tier-${alert.severity}`;
  return (
    <div className={`alert-card ${tierClass}`}>
      <div className="alert-card__header">
        <strong>{alert.student.username}</strong>
        <span className="alert-card__category">{alert.category}</span>
      </div>
      <blockquote className="alert-card__quote">"{alert.evidenceQuote}"</blockquote>
      <p className="alert-card__reason">판단: {alert.llmReason}</p>
      <p className="alert-card__meta">
        감지: {new Date(alert.detectedAt).toLocaleString('ko-KR')} · {alert.llmModel}
      </p>
      <textarea
        className="alert-card__note"
        placeholder="메모 (선택)"
        value={note}
        onChange={(e) => setNote(e.target.value)}
      />
      <div className="alert-card__actions">
        <button type="button" onClick={() => onDetail(alert.id)}>세부 대화 보기</button>
        <button type="button" onClick={() => onReview(alert.id, 'confirmed', note)}>확인함</button>
        <button type="button" onClick={() => onReview(alert.id, 'false_positive', note)}>오탐지</button>
      </div>
    </div>
  );
}
